import type { UnlockKind } from './config';


export const ACHIEVEMENT_COSMETICS: Record<string, ReadonlyArray<readonly [UnlockKind, string]>> = {
  anima_balance: [
    ['badge', 'curious_eye'],
    ['title', 'friend_beacon'],
    ['badge', 'ink_stamp'],
    ['badge', 'neon_bolt'],
    ['badge', 'sword_shield'],
  ],
  anima_spent: [
    ['badge', 'shuriken'],
    ['badge', 'cassette'],
    ['title', 'vault_baron'],
    ['banner', 'gold_dust'],
    ['title', 'anima_alchemist'],
  ],
  unique_characters: [
    ['badge', 'vine'],
    ['avatar', 'vines'],
    ['title', 'collector'],
    ['badge', 'archive_keeper'],
    ['title', 'living_encyclopedia'],
    ['frame', 'gold_filigree'],
    ['title', 'star_archivist'],
  ],
  owned_common: [
    ['badge', 'deja_vu_mark'],
    ['banner', 'halftone'],
    ['frame', 'manga_panel'],
    ['avatar', 'static'],
    ['badge', 'echo_chamber'],
    ['avatar', 'glitch'],
    ['title', 'glitch_prince'],
  ],
  owned_uncommon: [
    ['banner', 'ink_wash'],
    ['title', 'sumi_poet'],
    ['avatar', 'butterflies'],
    ['frame', 'ink_brush'],
    ['frame', 'compass'],
    ['title', 'manga_lead'],
    ['avatar', 'constellation'],
  ],
  owned_rare: [
    ['badge', 'rare_spark'],
    ['frame', 'sakura'],
    ['badge', 'koi'],
    ['banner', 'lightning'],
    ['frame', 'thorns'],
    ['title', 'frost_monarch'],
    ['avatar', 'demon_eyes'],
  ],
  owned_epic: [
    ['badge', 'album_sprout'],
    ['badge', 'series_lantern'],
    ['title', 'page_turner'],
    ['avatar', 'mask_oni'],
    ['badge', 'comet'],
    ['frame', 'obsidian'],
    ['banner', 'prism'],
  ],
  owned_legendary: [
    ['badge', 'cherry_seal'],
    ['avatar', 'petals'],
    ['badge', 'legendary_ten'],
    ['badge', 'dragon_scale'],
    ['title', 'lucky_fool'],
    ['frame', 'halo_ring'],
    ['avatar', 'summoning'],
  ],
  owned_mythic: [
    ['avatar', 'horns'],
    ['badge', 'oni_fang'],
    ['badge', 'fox_mask'],
    ['badge', 'insolent_luck'],
    ['title', 'mythic_ten'],
    ['frame', 'dragon_scale'],
    ['avatar', 'kitsune'],
  ],
  owned_divine: [
    ['frame', 'shimenawa'],
    ['avatar', 'halo'],
    ['badge', 'phoenix'],
    ['badge', 'first_divine'],
    ['frame', 'nacre'],
    ['banner', 'divine_trio'],
    ['title', 'divine_touch'],
  ],
  animes_completed: [
    ['title', 'lore_keeper'],
    ['frame', 'stained'],
    ['banner', 'great_wave'],
    ['title', 'stained_saint'],
    ['banner', 'omnibus'],
    ['banner', 'shrine_night'],
    ['title', 'myth_weaver'],
  ],
  fragments_earned: [
    ['badge', 'first_polish'],
    ['badge', 'shard_chip'],
    ['badge', 'ember_coal'],
    ['frame', 'crystal'],
    ['avatar', 'embers'],
    ['title', 'shard_saint'],
  ],
  fragments_spent: [
    ['badge', 'vial'],
    ['title', 'ember_hand'],
    ['badge', 'spent_forge'],
    ['banner', 'embers_fall'],
    ['frame', 'flame_rim'],
  ],
  upgrades: [
    ['badge', 'gear'],
    ['frame', 'gears'],
    ['frame', 'awakened'],
    ['banner', 'ashen'],
    ['title', 'master_smith'],
    ['title', 'awakening_bell'],
    ['title', 'forge_hymn'],
  ],
  boosters_opened: [
    ['frame', 'pixel_bezel'],
    ['banner', 'speed_lines'],
    ['title', 'pack_storm'],
    ['badge', 'booster_storm'],
    ['title', 'booster_abyss'],
    ['frame', 'rune_ring'],
    ['frame', 'void_ring'],
  ],
  lucky_boosters_opened: [
    ['avatar', 'sparkles'],
    ['badge', 'pixel_coin'],
    ['badge', 'hex_dice'],
    ['badge', 'vinyl'],
    ['avatar', 'binary'],
    ['title', 'pity_breaker'],
    ['banner', 'neon_rain'],
  ],
  trades_completed: [
    ['badge', 'handshake'],
    ['frame', 'chainmail'],
    ['banner', 'ocean'],
    ['title', 'deal_maker'],
    ['title', 'pact_binder'],
  ],
  listing_sales: [
    ['frame', 'stamp_edge'],
    ['title', 'stamp_official'],
    ['banner', 'grid'],
    ['title', 'merchant'],
    ['frame', 'barbed'],
    ['title', 'gold_tongue'],
    ['banner', 'trade_baron'],
  ],
  listing_purchases: [
    ['avatar', 'sunglasses'],
    ['banner', 'film_grain'],
    ['avatar', 'pirate'],
    ['badge', 'wave_crest'],
    ['badge', 'market_mogul'],
  ],
  auctions_sold: [
    ['banner', 'fireflies'],
    ['title', 'pixel_hero'],
    ['avatar', 'explorer'],
    ['badge', 'anchor'],
    ['banner', 'spotlight'],
  ],
  auctions_won: [
    ['avatar', 'blush'],
    ['avatar', 'scanlines'],
    ['avatar', 'hud_reticle'],
    ['banner', 'sakura_storm'],
    ['title', 'auction_ghost'],
  ],
  bids_placed: [
    ['badge', 'stall_bell'],
    ['avatar', 'headphones'],
    ['badge', 'torii_gate'],
    ['badge', 'crane'],
    ['frame', 'chains'],
  ],
  friends_count: [
    ['title', 'reaction_heart'],
    ['title', 'social_hub'],
    ['avatar', 'neko_ears'],
    ['banner', 'team_spirit'],
  ],
  messages_sent: [
    ['badge', 'fan'],
    ['title', 'whisper_net'],
    ['badge', 'drum'],
    ['banner', 'code_rain'],
    ['frame', 'circuit'],
    ['title', 'terminal_root'],
    ['title', 'salon_host'],
  ],
  playtime_hours: [
    ['frame', 'neon_tube'],
    ['title', 'neon_idol'],
    ['avatar', 'angel_feathers'],
    ['banner', 'constellation'],
    ['title', 'gothic_relic'],
    ['frame', 'eclipse'],
    ['title', 'elite'],
  ],
  login_streak: [
    ['avatar', 'frost'],
    ['frame', 'frost_rim'],
    ['badge', 'streak_thirty'],
    ['badge', 'moon_rabbit'],
    ['avatar', 'moonlight'],
    ['title', 'streak_comet'],
    ['title', 'aurora_name'],
  ],
  login_days: [
    ['badge', 'hourglass'],
    ['avatar', 'rain'],
    ['badge', 'frost_flake'],
    ['title', 'dawn_regular'],
    ['banner', 'aurora'],
    ['frame', 'aurora_ring'],
  ],
  account_age_days: [
    ['avatar', 'bubbles'],
    ['banner', 'snow'],
    ['banner', 'vhs'],
    ['avatar', 'crown'],
    ['frame', 'gothic_arch'],
    ['title', 'century_soul'],
  ],
  quests_completed: [
    ['badge', 'novice_ribbon'],
    ['banner', 'confetti'],
    ['badge', 'lantern'],
    ['title', 'week_sentinel'],
    ['frame', 'laurel'],
    ['banner', 'sky_lanterns'],
    ['badge', 'quest_veteran'],
  ],
  player_level: [
    ['avatar', 'wings'],
    ['badge', 'crown_chip'],
    ['banner', 'nebula'],
    ['banner', 'summit'],
  ],
};
